import { C } from "../../lib/colors";

export const IllustrationAgents = () => (
  <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
    <rect width="320" height="200" rx="16" fill="#0C0F1A"/>
    {[0,1,2,3,4,5,6].map(i=>(
      <g key={i} transform={`translate(${20+i*42},${60+Math.sin(i)*18})`}>
        <rect width="34" height="44" rx="8" fill={`rgba(0,240,160,${0.05+i*0.02})`} stroke={`rgba(0,240,160,${0.15+i*0.04})`} strokeWidth="1"/>
        <rect x="8" y="8" width="18" height="4" rx="2" fill={`rgba(0,240,160,${0.3+i*0.05})`}/>
        <rect x="8" y="16" width="12" height="3" rx="1.5" fill="rgba(255,255,255,0.1)"/>
        <rect x="8" y="22" width="15" height="3" rx="1.5" fill="rgba(255,255,255,0.08)"/>
        <circle cx="17" cy="35" r="4" fill={`rgba(0,240,160,${0.2+i*0.06})`}/>
        <text x="17" y="38" textAnchor="middle" fontSize="5" fill={C.green} fontFamily="monospace">{["◎","✉","◈","✍","◉","◆","◷"][i]}</text>
      </g>
    ))}
    {[0,1,2,3,4,5].map(i=>(
      <line key={i} x1={`${37+i*42}`} y1={`${82+Math.sin(i)*18}`} x2={`${58+i*42}`} y2={`${82+Math.sin(i+1)*18}`}
        stroke="rgba(0,240,160,0.2)" strokeWidth="1" strokeDasharray="3,3"/>
    ))}
    <rect x="80" y="148" width="160" height="24" rx="6" fill="rgba(0,240,160,0.08)" stroke="rgba(0,240,160,0.2)" strokeWidth="1"/>
    <text x="160" y="164" textAnchor="middle" fontSize="9" fill={C.green} fontFamily="monospace" letterSpacing="2">7 AGENTS RUNNING</text>
    <circle cx="296" cy="20" r="6" fill="rgba(0,240,160,0.15)" stroke={C.green} strokeWidth="1"/>
    <circle cx="296" cy="20" r="3" fill={C.green}/>
  </svg>
);
